import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 0c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 9 16c-2.875 0-5.5-1.5-6.937-4-1.438-2.469-1.438-5.5 0-8A8.02 8.02 0 0 1 9 0m-.75 3.75V8c0 .25.125.5.313.625l3 2c.343.25.812.156 1.062-.187a.795.795 0 0 0-.219-1.063L9.75 7.625V3.75A.76.76 0 0 0 9 3a.74.74 0 0 0-.75.75"
    }, null, -1)
  ])))
}
export default { render: render }